import {watch} from "vue";
import type {DirectiveBinding, Directive} from "vue";
import {Router} from "vue-router";

type HTMLElementWithUnwatcher = HTMLElement & {
    sfvScrollTopOnRouteChangeUnwatcher?: () => void
}

const vScrollTopOnRouteChange: Directive = {
    // We need to pass route object
    mounted(el: HTMLElementWithUnwatcher, binding: DirectiveBinding<Router>) {
        if (!binding.value?.currentRoute.value.path) {
            throw new Error("vScrollTopOnRouteChange: router object required");
        }
        el.sfvScrollTopOnRouteChangeUnwatcher = watch(
            () => binding.value.currentRoute.value.path,
            () => el.scroll({top: 0, behavior: "smooth"})
        );
    },
    beforeUnmount(el: HTMLElementWithUnwatcher) {
        el.sfvScrollTopOnRouteChangeUnwatcher?.();
    }
};

export default vScrollTopOnRouteChange;
